function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackArrow = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../../SVG");
var _styles = require("../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "color", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var BackArrow = exports.BackArrow = (0, _react.memo)(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (0, _styles.getREM)(1.0625) : _ref$size,
    color = _ref.color,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, Object.assign({
    testID: "BackArrow",
    viewBox: "0 0 17 14",
    fill: "none",
    style: [{
      width: size,
      height: size
    }, style],
    title: "back arrow icon"
  }, props, {
    children: (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      d: "M0.884913 7.85187L5.9764 12.9434C6.44567 13.4126 7.20472 13.4122 7.67356 12.9434C8.1424 12.4745 8.1424 11.715 7.67356 11.2462L4.61952 8.19215L15.3172 8.19088C15.9731 8.19088 16.5073 7.6567 16.5077 7.00032C16.5081 6.34394 15.9727 5.80849 15.3159 5.80849L4.6174 5.80637L7.67059 2.75317C8.13986 2.28391 8.13943 1.52485 7.67059 1.05601C7.20175 0.587166 6.44227 0.587167 5.97343 1.05601L0.881944 6.14749C0.413952 6.61549 0.415648 7.3826 0.884913 7.85187Z",
      fill: color != null ? color : colors.text
    })
  }));
});